import React from 'react';
import { createUseStyles } from 'react-jss';
import { Theme } from '@app/theme';
import { useMe, useParticipant } from '@app/api';
import { Button } from '@app/core';
import { OnboardingLayout } from './OnboardingLayout';
import { OnboardingButtons } from './OnboardingButtons';
import { useTranslation } from 'react-i18next';

const useStyles = createUseStyles((theme: Theme) => ({
  page: {
    backgroundColor: theme.colors.grayBackground,
    minHeight: '100%',
  },
  title: {
    ...theme.fonts.h2,
    marginTop: theme.marginBase * 6,
  },
  info: {
    ...theme.fonts.caption,
    backgroundColor: theme.colors.blueMuted,
    color: theme.colors.blueAccessible,
    padding: theme.marginBase * 2,
    borderRadius: theme.borderRadius.std,
    marginTop: theme.marginBase * 7,
  },

  content: {
    marginTop: 0,
    marginBottom: 0,
  },

  button: {
    [theme.media.mobile]: {
      width: '100%',
    },
  },
}));
export const Onboarding = () => {
  const classes = useStyles();
  const { t } = useTranslation();

  const { data: me } = useMe();
  const { data: participant } = useParticipant(
    me?.linkedParticipants?.length ? me.linkedParticipants[0] : undefined,
  );
  return (
    <OnboardingLayout isLoading={!participant}>
      <h1 className={classes.title}>
        {t('onboarding.welcome.title', { firstName: participant?.firstName })}
      </h1>
      <div className={classes.info}>{t('onboarding.welcome.description')}</div>
      <OnboardingButtons>
        <Button
          small
          className={classes.button}
          withNextArrow
          to="/onboarding/steps/Demographic"
        >
          {t('onboarding.continue')}
        </Button>
      </OnboardingButtons>
    </OnboardingLayout>
  );
};
